import axios from "axios";
import authService from "../authentication";

const instance = axios.create({
  // http://localhost:8080
  // 'https://rafcegh-api1.onrender.com'
    baseURL: 'https://api.rafce.com/api/v1',
  });
  
  // Automatically attach token to every request
instance.interceptors.request.use(
  (config) => {
    const token = authService.getCurrentUser();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


  instance.interceptors.request.use(
  (config) => {
    const token = authService.getCurrentUser();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;